import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './i18n';
import Header from './components/Header';
import MainContent from './components/MainContent';
import Footer from './components/Footer';
import GlobalStyle from './styles/GlobalStyle';
import Home from './pages/Home';
import About from './pages/About';
//import Services from './pages/Services';
import Contact from './pages/Contact';
import Error404 from './pages/Error404';

const navLinks = [
  { name: 'Home', href: '/' },
  { name: 'About', href: '/about' },
  { name: 'Contact', href: '/contact' },
];
{/*{ name: 'Services', href: '/services' },*/}

const App = () => (
  <Router>
    <GlobalStyle />
    <Header navLinks={navLinks} />
    <MainContent>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        {/*<Route path="/services" element={<Services />} />*/}
        <Route path="/contact" element={<Contact />} />
        <Route path="*" element={<Error404 />} />
      </Routes>
    </MainContent>
    <Footer />
  </Router>
);

export default App;
